import { h, Host } from "@stencil/core";
import { AppState } from "../../service/app-state";
export class Offcanvas {
    constructor() {
        this.open = false;
        this.changeListener = () => {
            this.open = AppState.offcanvas;
        };
    }
    openChanged(open) {
        if (open) {
            document.body.classList.add('offcanvas-active');
        }
        else {
            document.body.classList.remove('offcanvas-active');
        }
    }
    componentDidLoad() {
        this.open = AppState.offcanvas;
        AppState.addEventListener(this.changeListener);
    }
    disconnectedCallback() {
        AppState.removeEventListener(this.changeListener);
    }
    render() {
        const backdropProps = {
            class: `offcanvas-backdrop ${this.open ? 'open' : ''}`,
            onClick: () => AppState.toggleOffcanvas()
        };
        return h(Host, { key: '6afc25dd59d5362abc70f9a8618d666187f95775' }, h("slot", { key: '50ca06c5332c2787215967540bfdf443fbbd3228' }), h("div", Object.assign({ key: '988172c0aff87a0ed3bd342d88f9f0c49f1c8350' }, backdropProps)));
    }
    static get is() { return "uvex-offcanvas"; }
    static get originalStyleUrls() {
        return {
            "$": ["./offcanvas.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["offcanvas.css"]
        };
    }
    static get states() {
        return {
            "open": {}
        };
    }
    static get watchers() {
        return [{
                "propName": "open",
                "methodName": "openChanged"
            }];
    }
}
//# sourceMappingURL=offcanvas.js.map
